export default "__VITE_ASSET__BbrK6iux__"